import React, { Component } from 'react';

export default class Checkbox extends Component {

  state = {
    checked: this.props.checked || false,
  };

  check = (e) => {
    const checked = !this.state.checked;

    this.setState({ checked });

    if (this.props.onClick) {
      e.target.value = checked;
      this.props.onClick(e);
    }
  };

  render() {
    const { text = '' } = this.props;

    return (
      <div className="checkbox hover" onClick={this.check}>
        <input type="checkbox" onChange={this.check} checked={this.state.checked} />
        <label />
        <span>{text}</span>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js